import { createReducer, on } from '@ngrx/store';
import { filterPhotoGalleries, filterWebshops } from '../actions/filter.actions';

export interface FilterState {
  webshopFilter: WebshopFilter;
  photoGalleryFilter: PhotoGalleryFilter;
}

export interface WebshopFilter {
  search: string;
}

export interface PhotoGalleryFilter {
  search: string;
}

export const initialFilterState: FilterState = {
  webshopFilter: {
    search: ''
  },
  photoGalleryFilter: {
    search: ''
  }
}

export const filterReducer = createReducer(
  initialFilterState,
  on(filterWebshops, (state, {payload}) => handleFilterWebshops(state, payload)),
  on(filterPhotoGalleries, (state, {payload}) => handleFilterPhotoGalleries(state, payload)),
);

const handleFilterWebshops = (state: FilterState, payload: string) => ({...state, webshopFilter: {search: payload}})
const handleFilterPhotoGalleries = (state: FilterState, payload: string) => ({
  ...state,
  photoGalleryFilter: {search: payload}
})
